<template>
  <div class="checkout__section card">
    <h4 class="checkout__section-tit">
      Plano {{ ui.isMarketPlace ? 'MARKETPLACE' : 'PREMIUM' }}
    </h4>

    <ul
      v-if="ui.hasLoaded"
      class="features"
    >
      <li
        v-for="(feature, index) in features"
        :key="`feature-item-${index}`"
        class="features__item"
      >
        <i class="icon icon-check" />
        {{ feature }}
      </li>
    </ul>

    <p
      v-if="ui.hasLoaded"
      class="features__see-more"
      @click="ui.showMore = !ui.showMore"
    >
      <template v-if="ui.showMore">
        [-] ver menos
      </template>

      <template v-if="!ui.showMore">
        [+] ver todas as vantagens
      </template>
    </p>

    <hr class="separator" />

    <template v-if="ui.hasLoaded">
      <template v-if="!ui.hasCoupon">
        <p class="price price--full">
          R$ {{ getPlanFinalPrice() | toBRL }}
        </p>
      </template>

      <template v-if="ui.hasCoupon">
        <div class="px-4">
          <div class="flex flex-row items-center justify-start">
            <p class="m-0 p-0 w-4">
              de
            </p>

            <p class="price price--old">
              R$ {{ getPlanFinalPrice() | toBRL }}
            </p>
          </div>

          <div class="flex flex-row items-center justify-start">
            <p class="m-0 p-0 w-4">
              por
            </p>

            <p class="price price--new">
              R$ {{ getPlanPriceCoupon() | toBRL }}
            </p>
          </div>

          <div
            v-if="ui.hasCoupon && !apmMember"
            class="flex flex-row items-center justify-start mt-3 mb-3"
          >
            <dr-icon
              fill="#51DB81"
              color="#51DB81"
              name="coupon"
              class="h-6 w-6 mr-2"
            />

             <p
              class="m-0 p-0"
            >
              cupom
              <span class="text-green uppercase font-bold">
                {{ coupon.code }}
              </span>
              ({{ discount }})
            </p>

            <!-- <p
              v-if="ui.hasCoupon && !apmMember"
              class="m-0 p-0"
            >
              cupom
              <span class="text-green uppercase font-bold">
                {{ coupon.code }}
              </span>
              ({{ discount }})
            </p>
            <p
              v-else
              class="m-0 p-0"
            >
              Desconto de
              <span class="text-green uppercase font-bold">
                Associado APM
              </span>
            </p> -->
          </div>

          <div
            v-if="ui.hasCoupon && apmMember"
            class="flex flex-row items-center justify-start mt-3 mb-3"
          >
            <dr-icon
              fill="#51DB81"
              color="#51DB81"
              name="coupon"
              class="h-6 w-6 mr-2"
            />

            <p
              class="m-0 p-0"
            >
              Desconto de
              <span class="text-green uppercase font-bold">
                Associado APM
              </span>
            </p>
          </div>

          <div
            v-if="ui.hasMarketPlaceDiscount"
            class="flex flex-row items-center justify-start mt-3 mb-3"
          >
            <dr-icon
              fill="#51DB81"
              color="#51DB81"
              name="coupon"
              class="h-6 w-6 mr-2"
            />

            <p
              v-if="ui.hasMarketPlaceDiscount"
              class="m-0 p-0"
            >
              desconto 50% Marketplace Dr. Conecta
            </p>
          </div>

        </div>
      </template>

      <!-- if user is a APM member -->
      <!-- <template  v-if="ui.hasCoupon && apmMember">
          <div class="px-4">
          <div class="flex flex-row items-center justify-start">
            <p class="m-0 p-0 w-4">
              de
            </p>

            <p class="price price--old">
              R$ {{ getPlanFinalPrice() | toBRL }}
            </p>
          </div>

          <div class="flex flex-row items-center justify-start">
            <p class="m-0 p-0 w-4">
              por
            </p>

            <p class="price price--new">
              R$ {{ getPlanPriceCoupon() | toBRL }}
            </p>
          </div>

          <div
            v-if="ui.hasCoupon"
            class="flex flex-row items-center justify-start mt-3 mb-3"
          >
            <dr-icon
              fill="#51DB81"
              color="#51DB81"
              name="coupon"
              class="h-6 w-6 mr-2"
            />

            <p
              class="m-0 p-0"
            >
              Desconto de
              <span class="text-green uppercase font-bold">
                Associado APM
              </span>
            </p>
          </div>
        </div>
      </template> -->

    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MARKETPLACE_DISCOUNT } from '@/globals/constants'

export default {
  name: 'CheckoutFeatures',

  filters: {
    toBRL (str) {
      const money = Number(str).toFixed(2)

      return money.replace(/^(\d{1,})\.(\d{1,2})$/gmi, '$1,$2')
    }
  },

  props: {
    hasCoupon: {
      type: Boolean,
      required: false,
      default: () => false
    },
    apmMember: {
      type: Boolean,
      required: false,
      default: () => false
    },
    discountApm: {
      type: Object,
      required: false,
      default: () => {
        return {
          discountValueType: 'MONETARY',
          discountValue: '0'
        }
      }
    }
  },

  data () {
    return {
      newPrice: null,
      coupon: null,
      ui: {
        hasLoaded: false,
        hasCoupon: false,
        showMore: false,
        hasMarketPlaceDiscount: false,
        isMarketPlace: false
      }
    }
  },

  computed: {
    ...mapGetters({ plan: 'getPlan' }),

    features () {
      if (this.ui.hasLoaded) {
        const features = this.ui.isMarketPlace
          ? [...this.PLANS_DATA.features]
          : [...this.PLANS_DATA.features].slice(1)

        return this.ui.showMore
          ? features
          : features.slice(0, 5)
      }

      return []
    },

    discount () {
      if (this.coupon && this.coupon.type === 'MONETARY') {
        return `R$${this.coupon.value}`
      }

      if (this.coupon && this.coupon.type === 'PERCENTAGE') {
        return `${this.coupon.value}%`
      }

      return null
    },

    price () {
      if (this.ui.isMarketPlace) {
        return this.plan.marketplacePrice
      }

      return this.plan.premiumPrice
    }
  },

  watch: {

    discountApm: {
      deep: false,
      immediate: false,
      handler (v) {
        if (v) {
          if (Number(v.discountValue) > 0) {
            this.coupon = {
              type: v.discountValueType,
              value: v.discountValue
            }
            this.ui.hasCoupon = true
          }
        }
      }
    },
    hasCoupon: {
      deep: false,
      immediate: false,
      handler (v) {
        if (v) {
          this.getCoupons()
        }
      }
    }
  },

  created () {
    this.getPlans()
      .then(() => this.getCoupons())
      .finally(() => {
        this.ui.hasLoaded = true
      })
  },

  methods: {
    getPlans () {
      const url = '/subscription_plan?itensPerPage=all'

      this.fn_SHOW_PROGRESS()
      return this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          const { value: premiumPrice, id: premiumId } = res.data.data.find((plan) => /^premium$/i.test(plan.name))
          const { value: proPrice } = res.data.data.find((plan) => /^pro$/i.test(plan.name))
          const { value: marketplacePrice } = res.data.data.find((plan) => /^premium agenda available$/i.test(plan.name))

          this.$store.dispatch('setPlan', { premiumPrice, proPrice, premiumId, marketplacePrice })
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
        })
    },

    getCoupons () {
      const url = '/user/promotional_code_user?filterAndIsNull[upc.isUsed]=0'

      this.ui.hasLoaded = false
      this.fn_SHOW_PROGRESS()
      return this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          if (res.data.data.length > 0) {
            const {
              code,
              'discount_value_type': type,
              value
            } = res.data.data[0]['promotional_code']

            this.coupon = { code, type, value }
            this.ui.hasCoupon = true
          }
        })
        .then(this.checkHealthplaceRequirements)
        .then((status) => {
          // this.ui.hasMarketPlaceDiscount = status
          this.ui.isMarketPlace = status
        })
        .finally(() => {
          this.ui.hasLoaded = true
          this.fn_HIDE_PROGRESS()
        })
    },

    getPlanPriceCoupon () {
      const price = this.getPlanFinalPrice()
      let finalPrice = price

      if (this.ui.hasCoupon) {
        const discount = this.coupon.value
        const type = this.coupon.type

        switch (true) {
          case type === 'MONETARY':
            finalPrice = Number(price) - Number(discount)
            break

          case type === 'PERCENTAGE':
            finalPrice = Number(price) - (Number(price) * (Number(discount) / 100))
            break

          default:
            finalPrice = price
            break
        }
      }

      this.newPrice = finalPrice

      return finalPrice
    },

    getPlanFinalPrice () {
      if (this.ui.hasMarketPlaceDiscount) {
        const price = this.price
        return price - (Number(price) - (Number(price) * (Number(50) / 100)))
      }

      return this.price
    },

    checkHealthplaceRequirements () {
      const url = '/doctor/doctor_health_place/has_agenda_available'

      return new Promise((resolve) => {
        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then((res) => {
            resolve(Boolean(res.data))
          })
          .catch(() => resolve(false))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '$vars';

.checkout {
  &__section {
    @apply p-3 mb-3;
    background: #f4f4f4;

    &-tit {
      color: $color-green;
      font-family: $font1;
      font-size: 1rem;
    }
  }
}

.features {
  @apply list-none m-0 p-0 mx-4 mt-2;

  &__item {
    @apply flex flex-row items-start justify-start;
    @apply mb-3;
    font-size: 0.7rem;

    i {
      @apply mt-1 mr-2;
    }
  }

  &__see-more {
    @apply w-full p-0 px-4 m-0 text-sm cursor-pointer;
    text-align: left;
    color: $color-blue;
  }
}

.separator {
  background: #E0E0E0;
  border: 0;
  border-top: 1px solid #fff;
  height: 1px;
  margin: 1rem auto;
  width: 90%;
}

.price {
  @apply m-0 p-0 pl-4;
  font-size: 2rem;
  font-weight: 600;

  &--full {
    color: $color-blue;
  }

  &--old {
    color: #999999;
    font-size: 1.2rem;
    text-decoration: line-through;
  }

  &--new {
    color: $color-green;
  }
}
</style>
